import React, { FC } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSuitcase } from "@fortawesome/pro-regular-svg-icons/faSuitcase";

export const Suitcase: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faSuitcase} {...props} />
);
